import React, { memo } from "react";
import BookingCalendar from "../../components/calendar/BookingCalendar";
import SectionDateRangeSkeleton from "components/calendar/BookingCalendatSkeleton";
import { useFetchSingleAvailability } from "hooks/useFetchAvailabilities";
import { useTranslation } from "react-i18next";

// Move constants outside component
const CONSTANTS = {
  INTERNAL_ID: "c5f2207f-22b7-4d46-8206-7be30581221d",
  LISTING_ID: "569563",
  INTEGRATION_TYPE: "lodgify",
  ACTION: "fetchLodgifyListingAvailabilities",
} as const;

interface BookingCalendarWrapperProps {
  className?: string;
}

const BookingCalendarWidget: React.FC<BookingCalendarWrapperProps> = memo(
  ({ className = "" }) => {
    const { t } = useTranslation();
    const { availability, loading, error } = useFetchSingleAvailability(
      CONSTANTS.INTERNAL_ID,
      CONSTANTS.LISTING_ID,
      CONSTANTS.INTEGRATION_TYPE,
      CONSTANTS.ACTION
    );

    const availabilities = Array.isArray(availability) ? availability : [];

    if (error) {
      return (
        <div className="p-5 text-red-500">
          {t("Error loading calendar availability")}
        </div>
      );
    }

    if (loading) {
      return <SectionDateRangeSkeleton />;
    }

    return (
      <div className={`p-5 ${className}`}>
        <div className="listingSection__wrap overflow-hidden shadow-lg rounded-2xl bg-white dark:bg-neutral-900">
          <h2 className="text-2xl font-semibold">{t("Availability")}</h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            {t("Prices may increase on weekends or holidays")}
          </span>
          <div className="w-14 border-b border-neutral-200 dark:border-neutral-700" />
          <BookingCalendar availabilities={availabilities} />
        </div>
      </div>
    );
  }
);

BookingCalendarWidget.displayName = "BookingCalendarWidget";

export default BookingCalendarWidget;
